namespace $ {
	export class $shm_hitalama_benchmarks_catalog_run extends $giper_baza_entity.with({
		Meta: $giper_baza_atom_dict,
		Rows: $giper_baza_dict_to($giper_baza_atom_dict),
	}) {}
}
